import { createRoute } from '@tanstack/react-router';
import { adminParentRoute } from 'pages/admin/adminParentRoute';

export const adminIngestionHubNewRoute = createRoute({
  getParentRoute: () => adminParentRoute,
  path: '/tools/ingestions/new-ingestion',
}).lazy(() =>
  import('pages/admin/IngestionsHub/AdminIngestionsHubNewPage/AdminIngestionHubNewPage').then(
    (d) => d.Route
  )
);
